import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteFloor: { floor: { id: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.deleteFloor.floor.id,
  name: 'Floor',
})

export default function deleteFloor(id: string) {
  return client.gql.mutate({ mutation, variables: { input: { id } } }).then(mutateHandler)
}

const mutation = gql`
  mutation deleteFloor($input: DeleteFloorMutationInput!) {
    deleteFloor(input: $input) {
      floor {
        id
      }
    }
  }
`
